import { useLocation, useNavigate } from 'react-router-dom';
import { FC, useEffect } from 'react';

import {
    getDefaultFiltersQuery,
    getUserDefaultFiltersQuery,
    getUserSettingsQuery,
} from 'api/queries/user';
import { changeSplashScreen, setUser } from 'store/auth/authSlice';
import { auth } from 'utils/config/firebase';
import { useAppDispatch } from 'app/hooks';
import { signOut } from 'firebase/auth';
import { errorLogger } from 'utils/config/firebase/logs';
import { useAuthRedirect } from 'hooks/useAuthRedirect';

export const Auth: FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { setRedirect } = useAuthRedirect();

    useEffect(() => {
        async function checkUser() {
            try {
                await auth.authStateReady();
                const user = auth.currentUser;

                if (!user) {
                    throw new Error();
                }

                dispatch(setUser({ isLoggedIn: true, ...user }));
                getUserSettingsQuery(dispatch);
                getUserDefaultFiltersQuery(dispatch);
                getDefaultFiltersQuery(dispatch);
            } catch (error) {
                if (error instanceof Error) {
                    errorLogger.low(error?.message, 'auth -> checkUser');
                }
                console.log(error);
                signOut(auth);
                setRedirect(`${location.pathname}${location.search}`);
                navigate('/sign-in');
                dispatch(changeSplashScreen(false));
            }
        }
        checkUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
